import React from 'react';

export type KpiTone = 'default' | 'danger' | 'warn' | 'good';

export interface Kpi {
  label: string;
  value: React.ReactNode;
  note?: string;
  tone?: KpiTone;
}

const toneCls: Record<KpiTone, string> = {
  default: 'text-gray-900',
  danger: 'text-red-600',
  warn: 'text-amber-600',
  good: 'text-green-600',
};

/**
 * A 4-up (responsive) strip of headline metrics shown above each Workforce tab.
 * Purely presentational — the parent computes the numbers from real data.
 */
const KpiRow: React.FC<{ items: Kpi[] }> = ({ items }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 rounded-xl border border-gray-200 bg-white overflow-hidden mb-6">
    {items.map((k, i) => (
      <div
        key={k.label}
        className={`p-4 border-gray-100 ${i % 2 === 0 ? 'border-r' : ''} ${i < 2 ? 'border-b lg:border-b-0' : ''} lg:border-r lg:last:border-r-0`}
      >
        <div className="text-[11px] font-medium uppercase tracking-wide text-gray-400">{k.label}</div>
        <div className={`text-2xl font-bold mt-1 ${toneCls[k.tone || 'default']}`}>{k.value}</div>
        {k.note && <div className="text-xs text-gray-500 mt-0.5">{k.note}</div>}
      </div>
    ))}
  </div>
);

export default KpiRow;
